import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  message,
} from "antd";
import { collection, doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../../../firebase";
import dayjs from "dayjs";

const MarketingInformation = ({ data, dataId, isUpdate,companyName }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);

  const { TextArea } = Input;

  const dateFormat = "YYYY/MM/DD";
  const initialValues = {
    removedFromVacanciesList: data?.removedFromVacanciesList,
    availableOn: data?.availableOn ? dayjs(data?.availableOn, dateFormat) : "",
    marketingTitle: data?.marketingTitle,
    marketingDescription: data?.marketingDescription,
    youTubeVideoURL: data?.youTubeVideoURL,
  };

  const onFinish = (fieldsValue) => {
    const values = {
      ...fieldsValue,
      availableOn: fieldsValue["availableOn"]
        ? fieldsValue["availableOn"].format(dateFormat)
        : null,
    };
    console.log("Success:", values);
    console.log("iididi:", dataId);
    isUpdate(true);
    setIsWaiting(true);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);
      updateDoc(propertyDocRef, {
        "marketingInformation.removedFromVacanciesList":
          values.removedFromVacanciesList || "",
        "marketingInformation.availableOn": values.availableOn || "",
        "marketingInformation.marketingTitle": values.marketingTitle || "",
        "marketingInformation.marketingDescription":
          values.marketingDescription || "",
        "marketingInformation.youTubeVideoURL": values.youTubeVideoURL || "",
      });
      message.success("Marketing Information Data Updated Successfully..", 3);
      setIsEditActive(false);
      setTimeout(() => {
        setIsEditActive(false);
        setIsWaiting(false);
      }, 3000);
    } catch (error) {
      console.error("not updated:", error);
      message.error("Failed to update Marketing Information data", 3);

      setIsWaiting(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setIsWaiting(false);
  };
  return (
    <div>
      <Card
        title="Marketing Information"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          autoComplete="off"
          colon={false}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="Posted to your Website">
            <p>{data?.postedToYourWebsite ? "Yes" : "No"}</p>
          </Form.Item>
          <Form.Item label="Posted to the Internet">
            <p>{data?.postedToTheInternet ? "Yes" : "No"}</p>
          </Form.Item>
          <Form.Item label="Premium Leads">
            <p>{data?.premiumLeads ? "On" : "Off"}</p>
          </Form.Item>
          <Form.Item
            label="Removed from Vacancies List"
            name="removedFromVacanciesList"
            valuePropName="checked"
          >
            {isEditActive ? (
              <Checkbox></Checkbox>
            ) : (
              <p>{data?.removedFromVacanciesList ? "Yes" : "No"}</p>
            )}
          </Form.Item>
          <Form.Item label="Available On" name="availableOn">
            {isEditActive ? (
              <DatePicker format={dateFormat} style={{ width: "50%" }} />
            ) : (
              <p>{data?.availableOn === "" ? "--" : data?.availableOn}</p>
            )}
          </Form.Item>
          <Form.Item label="Marketing Title" name="marketingTitle">
            {isEditActive ? (
              <Input />
            ) : (
              <p>{data?.marketingTitle === "" ? "--" : data?.marketingTitle}</p>
            )}
          </Form.Item>
          <Form.Item label="Marketing Description" name="marketingDescription">
            {isEditActive ? (
              <TextArea
                style={{
                  height: 120,
                  resize: "none",
                }}
              />
            ) : (
              <p>
                {data?.marketingDescription === ""
                  ? "--"
                  : data?.marketingDescription}
              </p>
            )}
          </Form.Item>
          <Form.Item label="YouTube Video URL" name="youTubeVideoURL">
            {isEditActive ? (
              <Input />
            ) : (
              <a>
                {data?.youTubeVideoURL === "" ? "--" : data?.youTubeVideoURL}
              </a>
            )}
          </Form.Item>
          {isEditActive && (
            <Row gutter={16}>
              <Col>
              <Button type="primary" htmlType="submit" disabled={isWaiting}>
                  {isWaiting ? "Please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default MarketingInformation;
